// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"a1aa5ddb","453":"132adb73","796":"32614a06"}[chunkId] + ".chunk.js";
};